import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { productServices } from '@hero/services';
import { createQueryKey } from '@hero/utils';

export const useGetProductDetail = (productId = {}, options = {}) =>
  useQuery(
    createQueryKey(QUERY_KEYS.useGetProductDetailKey, { productId }),
    () => productServices.getProductDetail(productId),
    {
      staleTime: 1000 * 60 * 5,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      ...options
    }
  );
